import styled from "styled-components";
import employerIcon from "../assets/images/employersIcon.svg";
import picture5 from "../assets/images/Picture5.png";
import picture6 from "../assets/images/Picture6.png";
import picture7 from "../assets/images/Picture7.png";
import { Link } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../styles/Button.styles";
import { device } from "../styles/Responsive.style";


const Employers = () => {
    return (
        <PageWrapper>
            <Top>
                <img src={employerIcon} alt="employer icon"/>
                <h1>Unlock the digital potential in your organisation</h1>
                <p>The attriDNA tool gives you a new lens on potential talent.</p>
                <p>Our diagnostic reveals the attributes that drive success in your teams - helping you recruit smarter, develop talent faster, and retain workforce skills.</p>
            </Top>
            <QuoteBlock>
                <div>❞</div>
                <p>After completing attriDNA, I am more likely to consider a career in Cyber Security. It had a significant impact on me, sparking my interest in learning and practicing cyber security further</p>
                <h4>-Participant</h4>
            </QuoteBlock>
            <Middle>
                <h3>How it works</h3>
                <h4>1. Invite individuals to complete the questionnaire</h4>
                <p>Get quick insights from potential or current employees.</p>
                <h4>2. Access attribute analytics</h4>
                <p>See the strengths and gaps in your team through data visualisations and comparative dashboards.</p>
                <h4>3. Transform your workforce</h4>
                <p>Use insights to recruit more effectively, upskill existing staff, and align development to real-world business needs.</p>
                <div>
                    <img src={picture5} alt="questionnaires" />
                    <img src={picture6} alt="questionnaire" />
                    <img src={picture7} alt="results" />
                </div>
            </Middle>
            <QuoteBlock>
                <div>❞</div>
                <p>I was impressed with all the questions . The most interesting part was to find out what job opportunities are out there be after completing attriDNA</p>
                <h4>-Participant</h4>
            </QuoteBlock>
            <Bottom>
                <h3>Benefits for you</h3>
                <h4>Reveal hidden talent - Identify high-potential individuals across all departments.</h4>
                <h4>Bridge your digital skills gap - Build capability from within before hiring externally.</h4>
                <h4>Reduce recruitment costs - Target candidates who fit your team culture and strengths.</h4>
                <h4>Accelerate digital transformation - Develop a workforce ready for tomorrow’s technology.</h4>
                <h4>Boost engagement and retention - Empower employees with career growth insights.</h4>
            </Bottom>
            <BannerSecondary>
                <h2>To complete your questionnaire as an individual</h2>
                <Link to="/invite/7e9373d3-6a3a-4e19-bbd2-815c8288c869/68e6c75a0c591744e47b0702">
                    <PrimaryButton>
                        Click Here
                    </PrimaryButton>
                </Link>
            </BannerSecondary>
            <Banner>
                <h2>To get in touch if you’re interested in an employer solution</h2>
                <a href="mailto:enquiries@attridna.ai">
                    <SecondaryButton >
                        Click Here
                    </SecondaryButton>
                </a>
            </Banner>
        </PageWrapper>
    )
}

export default Employers;

const PageWrapper = styled.main`
    width: 100%;
    max-width: 1500px;
    padding: 0 50px;
    box-sizing: border-box;
    margin: 0 auto;
`

const QuoteBlock = styled.div`
    position: relative;
    background: var(--bg-main-light);
    border-radius: 10px;
    padding: 40px 80px;
    margin: 80px 0 40px 0;

    div {
        font-size: 180px;
        color: var(--secondary-gray);
        position: absolute;
        top: -95px;
        left: 40px;
    }

    p {
        margin: 0;
    }

    h4 {
        margin: 5px 0 0 0;
        text-align: right;
    }
`;

const Top = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 40px 0;

    img {
        height: 100px;
    }
`;

const Middle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    div {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        width: 100%;

        img {
            margin: 5px;
            height: 220px;
        }
    }

    h3 {
        font-size: var(--font-medium);
        margin: 10px 0;
    }

    h4 {
        margin-bottom: 0;
    }
    p {
        margin-top: 0;
    }

    @media ${device.medium} {
        div {
            display: flex;
            justify-content: space-around;
            flex-wrap: wrap;
            width: 100%;

            img {
                margin: 5px;
                width: 100%;
                height: auto;
            }
        }
    }
`;

const Bottom = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 40px 0;

    h3 {
        font-size: var(--font-medium);
        margin: 10px 0;
    }

    h4 {
        background: var(--bg-main-light);
        padding: 20px;
        width: 100%;
        border-radius: 5px;
        margin: 5px;
        box-sizing: border-box;
        font-weight: 400;
    }
`;

const Banner = styled.div`
    border-radius: 10px;
    background: linear-gradient(45deg, var(--accent), var(--orange));
    display: grid;
    place-items: center;
    padding: 40px 10px;

    h2 {
        margin: 0;
        font-size: var(--font-medium);
    }

    a {
        background: white;
        color: black;
        text-decoration: none;
        padding: 5px;
        border-radius: 10px;
        margin-top: 20px;
    }
`;

const BannerSecondary = styled.div`
    border-radius: 10px;
    background: linear-gradient(45deg, var(--dark-bg), var(--gray-dark));
    display: grid;
    place-items: center;
    padding: 40px 10px;
    margin-bottom: 20px;

    h2 {
        margin: 0;
        font-size: var(--font-medium);
    }

    a {
        margin-top: 20px;
    }
`;